const getIntervalParams = (activeTab, startDate, endDate) => {
    const params = {}
    switch (activeTab) {
        case 'last24Hours':
            params.interval = '1-days'
            break;
        case 'last7Days':
          params.interval = '7-days'
          break;
        case 'last30Days':
          params.interval = '30-days'
          break;
        case 'last365Days':
          params.interval = '365-days'
          break;
        case 'range':
            if (startDate && endDate) {
              params.startDate = startDate
              params.endDate = endDate
            } else {
              params.interval = '365-days'
            }
          break;
        default:
            throw new Error ('incorrect value recieved for activeTab')
      }
      return params
}

export default getIntervalParams